/**
 * API bearer token accessor for the service layer (sdk, dtaApi, auditApi). Delegates to the active
 * auth strategy so the correct token is attached for the current mode - the Cognito ID token for
 * native/federated, the IDP access token for direct-oidc - without any caller branching on mode.
 */

import { getAuthStrategy } from "./auth"

export async function getApiToken(): Promise<string> {
  return getAuthStrategy().getApiToken()
}
